import React from 'react';
import {
  PlusCircle as Add,
  Edit,
  ListChecks,
  MessageCircle,
  Trash as Remove
} from 'lucide-react';
import * as translations from './strings';
import { ARCHIVE_ALL_MENU_KEY } from './types';
import ArchiveAll from './ArchiveAll';
import { getLangKey } from 'jsModels/Application';
import styles from './index.module.css';

const strings = translations[getLangKey()];

type Handler = () => void;

type Props = {
  handlers: {
    [key: string]: Handler;
  };
  archiveStage: string;
  cards: any[];
  archiveAllowed: boolean;
  unreadCommentsAllowed: boolean;
  archiveDisabled: boolean;
  deleteProps: {
    title?: string;
    disabled: boolean;
  };
  allSelected: boolean;
};

export const items = ({
  handlers,
  archiveStage,
  cards,
  archiveAllowed,
  unreadCommentsAllowed,
  archiveDisabled,
  deleteProps,
  allSelected
}: Props): {
  key: string;
  label: string | undefined;
  icon: React.ReactNode;
  onClick: Handler;
  hide?: boolean;
  disabled?: boolean;
  title?: string;
}[] => [
  {
    key: 'select_all',
    label: allSelected ? strings.unselectAll : strings.selectAll,
    icon: <ListChecks className={styles.actionIcon} />,
    onClick: handlers.selectAll
  },
  {
    key: 'add_task',
    label: strings.addTask,
    icon: <Add className={styles.actionIcon} />,
    onClick: handlers.addTask
  },
  {
    key: 'add_column',
    label: strings.addColumn,
    icon: <Add className={styles.actionIcon} />,
    onClick: handlers.addColumn
  },
  {
    key: 'rename_column',
    label: strings.renameColumn,
    icon: <Edit className={styles.actionIcon} />,
    onClick: handlers.renameColumn
  },
  {
    key: 'mark_all_as_read',
    label: strings.markAllAsRead,
    icon: <MessageCircle />,
    onClick: handlers.markAllAsRead,
    hide: !unreadCommentsAllowed
  },
  {
    key: ARCHIVE_ALL_MENU_KEY,
    label: undefined,
    icon: <ArchiveAll stage={archiveStage} taskCount={cards.length} />,
    onClick: handlers.archiveAll,
    hide: !archiveAllowed,
    disabled: archiveDisabled
  },
  {
    key: 'delete_column',
    label: strings.deleteColumn,
    icon: <Remove className={styles.actionIcon} />,
    onClick: handlers.deleteColumn,
    ...deleteProps
  }
];
